import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { Plus } from 'lucide-react';
import TripList from '../components/trips/TripList';
import { useAuth } from '../hooks/useAuth';

const TripsPage: React.FC = () => {
  const { isAuthenticated, user } = useAuth();
  const { routeId } = useParams<{ routeId?: string }>();

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Trips</h1>
            <p className="mt-2 text-gray-600">
              {routeId 
                ? `Showing trips for route ID: ${routeId}` 
                : "Find rides or offer your car to share trips with others."
              }
            </p>
          </div>
          
          {/* Create Trip Button */}
          {isAuthenticated && user?.roles?.some(role => role.name === 'driver') && (
            <Link
              to="/trips/create"
              className="inline-flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              <Plus className="h-4 w-4" />
              <span>Create Trip</span>
            </Link>
          )}
        </div>

        {/* Trip List */}
        <TripList routeId={routeId} />
      </div>
    </div>
  );
};

export default TripsPage;
